import { SuccessPaginationResponseType, SuccessResponseType } from "./main";

export enum DocumentType {
    DOCUMENT = 0,
    PHOTO = 1,
    LIST = 2,
    REPORT = 3,
}

export interface DocumentData {
    id: number;
    name: string;
    path: string;
    created_at: string;
    updated_at: string;
    format: number;
    documentable_id: number;
    documentable_type: string;
    tag_id: string | null;
    meta: string | null;
    tag: string | null;
}

export interface DocumentCreate {
    file: any;
    format: number;
    tag_id?: number;
}

export interface DocumentsSuccessResponse extends SuccessPaginationResponseType<Array<DocumentData>> {}

export interface DocumentSuccessResponse extends SuccessResponseType<DocumentData> {}
